import { useEffect, useState } from 'react'

declare global {
    interface Window {
        FB?: any
        fbAsyncInit?: () => void
    }
}

const SCRIPT_ID = 'facebook-jssdk'

/**
 * Carrega o SDK do Facebook sob demanda, e só nesta tela.
 *
 * Não vai no `index.html`: o SDK instala listeners globais e um iframe em toda
 * página que o carrega, e isso não tem por que existir nas outras ~200 telas do
 * sistema. Carregar aqui também evita que uma falha de rede do Facebook atrase
 * o primeiro render do app inteiro.
 *
 * `appId` e `graphVersion` vêm do servidor (painel master), então trocá-los não
 * exige build do front — por isso o hook recebe os dois em vez de lê-los de
 * variável de ambiente.
 */
export function useFacebookSdk(appId?: string, graphVersion?: string) {
    const [ready, setReady] = useState(false)
    const [failed, setFailed] = useState(false)

    useEffect(() => {
        if (!appId || !graphVersion) return

        if (window.FB) {
            setReady(true)
            return
        }

        window.fbAsyncInit = () => {
            window.FB?.init({
                appId,
                autoLogAppEvents: false,
                xfbml: false,
                version: graphVersion,
            })
            setReady(true)
        }

        if (document.getElementById(SCRIPT_ID)) return

        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.src = 'https://connect.facebook.net/pt_BR/sdk.js'
        script.async = true
        script.defer = true
        script.crossOrigin = 'anonymous'
        // Bloqueador de anúncios derruba este script com frequência. Sem o
        // onerror a tela ficaria carregando para sempre, sem dizer o motivo.
        script.onerror = () => setFailed(true)
        document.body.appendChild(script)
    }, [appId, graphVersion])

    return { ready, failed }
}
